module.exports = __webpack_public_path__ + "static/img/yy4.ae7b158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/yy4.png
// module id = p8U5
// module chunks = 1